/* eslint-disable import/prefer-default-export */
export const getBadgeTypeForStipLogStatus = (status: string): string => {
  const lowerStatus = status.toLowerCase();
  switch (true) {
    case lowerStatus.includes('_but_'):
      return 'danger';
    case lowerStatus.includes('in_processing'):
      return 'warning';
    default:
      return 'success';
  }
};
